/* eslint-disable react-refresh/only-export-components -- entry point, no exports expected */
import React from "react";
import ReactDOM from "react-dom/client";
import { MsalProvider } from "@azure/msal-react";
import { PublicClientApplication } from "@azure/msal-browser";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";

import App from "./App";
import { msal } from "./config";

import "./index.css";

export const pca = new PublicClientApplication(msal);

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 60,
      refetchOnWindowFocus: false,
    },
  },
});

// Component
const AppProvider = () => (
  <QueryClientProvider client={queryClient}>
    <MsalProvider instance={pca}>
      <App />
    </MsalProvider>
    <ReactQueryDevtools initialIsOpen={false} />
  </QueryClientProvider>
);

// MSAL v4: initialize() must complete before any MSAL API call.
// handleRedirectPromise() must run BEFORE React Router mounts. Otherwise the
// catch-all <Redirect> in App.tsx fires first on /home (the MSAL redirect URI),
// replacing the URL to /groups and stripping the #code fragment before MSAL
// can exchange it. With navigateToLoginRequestUrl=true (default), MSAL also
// restores the URL to where loginRedirect() was called from.
pca
  .initialize()
  .then(() => pca.handleRedirectPromise())
  .catch((error) => {
    console.error("MSAL redirect handling failed:", error);
  })
  .finally(() => {
    ReactDOM.createRoot(document.getElementById("root")!).render(
      <React.StrictMode>
        <AppProvider />
      </React.StrictMode>
    );
  });
